import Map from '@arcgis/core/Map';
import MapView from '@arcgis/core/views/MapView';
import Attribution from '@arcgis/core/widgets/Attribution';
import { normalizeCenterCoordinates, normalizeExtent } from '../../utils/utils';
import './themes/lightTheme.scss';

/**
 * Create the Map and MapView instances and returns them
 * @param {HTMLElement} mapContainer - The reference to the DOM element to
 * render themap
 * @param {Object} esriMapOptions - Options to create the Map instance with
 * @param {String} esriMapOptions.basemap - The basemap to use for the Map
 * @param {Object} esriViewOptions - Options to create the MapView instance with
 * @param {Array} esriViewOptions.center - Center point of the MapView
 */
export const createMap = async ({
  mapContainer,
  esriMapOptions = {},
  esriViewOptions = {},
}) => await handleMap({ mapContainer, esriMapOptions, esriViewOptions });

const handleMap = ({ mapContainer, esriMapOptions, esriViewOptions }) => {
  const map = new Map({
    ...esriMapOptions,
    basemap: esriMapOptions.basemap
      ? esriMapOptions.basemap
      : 'arcgis-navigation',
  });

  const view = new MapView({
    ...esriViewOptions,
    center: normalizeCenterCoordinates(esriViewOptions.center),
    container: mapContainer, // mapRef.current,
    map,
    zoom: 4,
    extent: normalizeExtent(esriViewOptions.shapes),
    constraints: {
      rotationEnabled: false,
    },
  });

  const attribution = new Attribution({
    view,
  });

  view.ui.add(attribution, 'manual');

  return { map, view, attribution };
};
